export default __webpack_public_path__ + "static/checkout-e51ca053bae4ed4e4de4202a79a686b0.png";